/**
 * Rotas do módulo de assinatura de termo via token
 *
 * RN03 - Experiência única de assinatura
 * RN06 - Autenticação via token
 *
 * Esta rota é pública e permite acesso direto ao termo via link com token
 */
export default [
    {
        path: '/term-signature/govbr/error',
        name: 'term-signature-govbr-error',
        component: () => import('./pages/GovBrError.vue'),
        meta: {
            public: true,
            title: 'Erro - Assinatura GOV.br'
        }
    },
    {
        path: '/term-signature/:token',
        name: 'term-signature',
        component: () => import('./pages/Index.vue'),
        meta: {
            public: true,
            title: 'Assinatura de Termo'
        }
    }
]
